document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-wits-variant-section]').forEach(function (wrapper) {
    const sectionId = wrapper.dataset.sectionId;
    const currency = wrapper.dataset.currency || 'USD';
    const locale = wrapper.dataset.locale || 'en-US';

    const variantsEl = wrapper.querySelector('[data-wits-product-variants]');
    if (!variantsEl) return;

    const variants = JSON.parse(variantsEl.textContent);

    const selects = wrapper.querySelectorAll('select[name^="options["]');
    const form = wrapper.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const mainVariantInput = form.querySelector('input[name="id"]');
    const installmentInput = document.querySelector(
      '#product-form-installment-' + sectionId + ' input[name="id"]'
    );

    const priceEl = wrapper.querySelector('#price-variant-wits');
    const stickyPrice = document.querySelector('.wits-sticky-cta-mobile .price');
    const addButton = wrapper.querySelector('.cert-button-primary');

    function formatMoney(cents) {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function getSelectedOptions() {
      return Array.from(selects).map(function (select) {
        return select.value;
      });
    }

    function findVariant() {
      const selectedOptions = getSelectedOptions();

      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });
    }

    function updateVariant() {
        const selectedOptions = getSelectedOptions();

        // If any dropdown is still on placeholder
        if (selectedOptions.includes('')) {
            if (addButton) {
            addButton.disabled = true;
            addButton.textContent = 'Select option';
            }
            return;
        }

        const variant = findVariant();
        if (!variant || !mainVariantInput) return;

        mainVariantInput.value = variant.id;

        if (priceEl) {
            priceEl.innerHTML = `
            <div class="price">
                <span class="price-item price-item--regular">
                ${formatMoney(variant.price)}
                </span>
            </div>
            `;
        }

        if (stickyPrice) {
            stickyPrice.textContent = formatMoney(variant.price);
        }

        if (addButton) {
            addButton.disabled = !variant.available;
            addButton.textContent = variant.available
            ? 'Add to cart'
            : 'Sold out';
        }

        if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
        }
        }

    selects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });

    updateVariant();
  });
});